module.exports = __webpack_public_path__ + "img/img_30@2x.3aae3f32.png";